import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import Auth from '../../../services/auth';
import { FAQ_URL } from '../../../config/constants';
import IconUser from '../../../assets/images/iconUser.png';

const auth = new Auth();

class DropdownProfile extends React.Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.state = {
			dropdownOpen: false
		};
		this.openFAQ = this.openFAQ.bind(this);
	}

	toggle() {
		this.setState(prevState => ({
			dropdownOpen: !prevState.dropdownOpen
		}));
	}
	
	openFAQ(){
		window.open(FAQ_URL, '_blank').focus();
	}

	render() {
		return (
			<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="dropdown navbar-user" tag="li">
				<DropdownToggle tag="a">
					<img src={IconUser} alt="" /> 
					<span className="d-none d-md-inline">Account</span> <b className="caret"></b>
				</DropdownToggle>
				<DropdownMenu className="dropdown-menu dropdown-menu-right" tag="ul">
					{/* <DropdownItem>Edit Profile</DropdownItem>
					<DropdownItem><span className="badge badge-danger pull-right">2</span> Inbox</DropdownItem>
					<DropdownItem>Calendar</DropdownItem>
					<DropdownItem>Setting</DropdownItem> */}
					<DropdownItem onClick={this.openFAQ}><i className='fa fa-question-circle'/> FAQ</DropdownItem>
					<div className="dropdown-divider"></div>
					<DropdownItem onClick={() => auth.logout()}><i className='fa fa-sign-out-alt'/> Log Out</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		);
	}
};

export default DropdownProfile;
